import { UserDto } from '@fleet-beat/core';

export interface TenantAuthResponseDto {
  user?: UserDto;
  refreshToken?: string;
  token?: string;
}
